import { Ticket } from "lucide-react";
import { VentureCard, VentureCardHeader, VentureCardTitle, VentureCardContent } from "@/components/ui/venture-card";

export function SalesTicketsTab() {
  return (
    <div className="space-y-6">
      <VentureCard>
        <VentureCardHeader>
          <VentureCardTitle className="flex items-center gap-2">
            <Ticket className="w-5 h-5 text-secondary" />
            Sales Support Tickets
          </VentureCardTitle>
        </VentureCardHeader>
        <VentureCardContent>
          <div className="text-center py-16">
            <Ticket className="w-16 h-16 mx-auto text-muted-foreground mb-6" />
            <h3 className="text-lg font-semibold mb-2">Sales tickets coming soon</h3>
            <p className="text-muted-foreground max-w-md mx-auto">
              Sales support tickets will appear here once the closer request and demo issue tracking systems are connected.
            </p>
          </div>
        </VentureCardContent>
      </VentureCard>
    </div>
  );
}
